import { useEffect, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';

function ScrollToTopButton() {
  const [visible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };

      window.addEventListener('scroll', toggleVisibility);

      return () => {
        window.removeEventListener('scroll', toggleVisibility);
      };
  }, [])

  const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // For smooth scrolling
      });
    };

  if (!visible) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 50,
        right: 50,
        zIndex: 9999,
      }}>
      <Button
        circular
        style={{
          background: "rgb(0, 100, 112)",
          color: "white",
          padding: "0.5rem"
        }}
        icon
        onClick={() => scrollToTop()}
      >
        <Icon name="chevron up" size="large" />
      </Button>
    </div>
  )
}

export default ScrollToTopButton